var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"btn",staticClass:"btn btn-outline-info",attrs:{"type":"button"}},[_c('i',{staticClass:"fas fa-paperclip"})])
}
var staticRenderFns = []

export { render, staticRenderFns }